import React from 'react';
import { convertIcon } from '../component/Icon';

interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 9.5L15.5 13L21.5 6"
        stroke="#616161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6321 5.5H4C3.17157 5.5 2.5 6.17157 2.5 7L2.5 17C2.5 17.8284 3.17157 18.5 4 18.5H20C20.8284 18.5 21.5 17.8284 21.5 17V12.8478"
        stroke="#616161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5.04272 15H12.4905" stroke="#616161" strokeLinecap="round" />
      <path d="M5.04272 11.9934H9.8306" stroke="#616161" strokeLinecap="round" />
      <path d="M5 9.05225H8.19192" stroke="#616161" strokeLinecap="round" />
    </svg>
  );
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'value');
export default IconComponent;
